import { render, staticRenderFns } from "./MyMatching.vue?vue&type=template&id=2928754e"
import script from "./MyMatching.vue?vue&type=script&lang=js"
export * from "./MyMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports